import { getDoc } from 'firebase/firestore'
import useFirebase from '../composables/useFirebase'
import type { VerifiedBsn } from '../models/VerifiedBsn'
import { PullService } from './servicePull'

export class VerifiedBsnPullService extends PullService<
  VerifiedBsn,
  VerifiedBsn[]
> {
  private doc

  constructor() {
    super()
    const { doc } = useFirebase()

    this.doc = doc
  }

  public async getById(userId: string): Promise<VerifiedBsn | undefined> {
    const verifiedBsn = await getDoc(
      this.doc<VerifiedBsn>('VerifiedBsns', userId),
    )
    if (!verifiedBsn.exists()) {
      return undefined
    }

    return verifiedBsn.data() as VerifiedBsn
  }
}
